import { render } from "./UserBlog.vue?vue&type=template&id=658e1246&scoped=true"
import script from "./UserBlog.vue?vue&type=script&lang=js"
export * from "./UserBlog.vue?vue&type=script&lang=js"

import "./UserBlog.vue?vue&type=style&index=0&id=658e1246&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658e1246"]])

export default __exports__